import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { Container } from './container';
import './index.scss';
export const CnCardItems = withI18n(Container, {
    locale,
    componentName: 'CnCardItems',
    _noHoc: true,
});
